import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SummaryService } from '../services/summary/summary.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  @Input() public consolidator: any;
  @Input() public allDays: any;
  @Input() public enableAccountBalanceServicePriceDetails: any;
  @Input() public isFlightTaxInSummaryIncluded: any;
  @Input() public setTaxFlightFee: any;
  @Input() public advInformations: any;
  @Input() public extra: any;
  @Input() public limitMarkup: any;
  @Input() public insuranceSummaryVisible: any;
  @Input() public showOnlyTotalPrice: any;
  @Input() public showOptionlServices: any;
  @Input() public showSummaryDetail: any;
  @Input() public passengers: any;
  @Input() public amountApis: any;
  @Input() public commissionType: any;
  @Input() public combinePriceServices: any;
  @Input() public totalPax: number = 0;
  @Input() public serviceIcons: any;
  @Output() eventAdvInformations = new EventEmitter<any>();
  state: any = sessionStorage.getItem('state');
  limit: any;
  amount: any;
  amountTotal: any;
  public historyFeeModalReference!: NgbModalRef;

  // Getter per il valore combinato
  get combinedFeeValue(): number {
    return (this.advInformations?.feeFlight || 0) + (this.advInformations?.feeLandServices || 0);
  }

  // Setter per il valore combinato - divide automaticamente tra feeFlight e feeLandServices
  set combinedFeeValue(value: number) {
    const halfValue = (value || 0) / 2;
    if (this.advInformations) {
      this.advInformations.feeFlight = halfValue;
      this.advInformations.feeLandServices = halfValue;
    }
  }

  public get withholdingTaxAmount(): number {
    const rawValue = this.amountApis?.withholdingTax;
    const parsed = Number(rawValue);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  public get hasWithholdingTax(): boolean {
    const rawValue = this.amountApis?.withholdingTax;
    return rawValue !== null && rawValue !== undefined && rawValue !== '' && this.withholdingTaxAmount !== 0;
  }

  constructor(private readonly modalService: NgbModal, private summary: SummaryService) {
  }

  ngOnInit(): void {
    console.log(this.amountApis);
    this.amount = this.summary.calculateTotals(this.allDays, this.extra);
    this.amountTotal = this.summary.getTotalAmount(this.amount.totalGroundService, this.amount.totalFlightsService, this.advInformations, this.amount.totalFeeInsuranceService);
    console.log(this.amount);
    console.log(this.amountTotal);
    console.log(this.advInformations);
  }

  public getTotal(arr: any) {
    let sum = arr.map((item: any) => item.amountaftertax + (item.adv_markup ? item.adv_markup : 0)).reduce((acc: number, curr: number) => acc + curr, 0);
    return sum;
  }

  maxLimit(total: any): number {
    this.limit = Math.trunc(total * (this.limitMarkup / 100))
    if (this.limitMarkup == 0) {
      this.limit = 99999999999;
      return 99999999999;
    }
    return this.limit;
  }

  checkLimit(event: Event) {
    const inputValue = (event.target as HTMLInputElement).value;

    if (+inputValue > this.limit) {
      (event.target as HTMLInputElement).value = inputValue.slice(0, -1); // Imposta l'input alla sottostringa che rispetta il limite
    }
  }

  maxLimitCombined(): number {
    const flightLimit = this.maxLimit(this.amountApis?.flightTicketsPrice || 0);
    const landLimit = this.maxLimit(this.amountApis?.baseTripPrice || 0);
    return flightLimit + landLimit;
  }


  setCustomerOutputAdvInformations() {
    this.advInformations.feeFlight = this.advInformations.feeFlight || 0;
    this.advInformations.feeLandServices = this.advInformations.feeLandServices || 0;
    this.advInformations.feeFlightTaxes = this.advInformations.feeFlightTaxes || 0;
    this.eventAdvInformations.emit({ feeFlight: this.advInformations.feeFlight, feeLandServices: this.advInformations.feeLandServices, footerText: this.advInformations.footerText, hidePriceB2C: this.advInformations.hidePriceB2C });
  }

  get uniqueHistory(): any[] {
    if (!this.advInformations?.history) return [];
    const withChange: any[] = this.advInformations.history.filter((h: any) => !!h.changed);
    return withChange.filter((h: any, i: number) => {
      if (i === 0) return true;
      const prev = withChange[i - 1];
      return (h.feeFlight ?? 0) !== (prev.feeFlight ?? 0) ||
             (h.feeLandServices ?? 0) !== (prev.feeLandServices ?? 0) ||
             (h.footerText ?? '') !== (prev.footerText ?? '') ||
             (h.hidePriceB2C ?? false) !== (prev.hidePriceB2C ?? false);
    }).reverse();
  }

  public openModal(historyFeeModal: any) {
    this.historyFeeModalReference = this.modalService.open(historyFeeModal);
  }

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  groupItemsByName(items: any[]): any[] {
    const groupedMap = new Map();

    items.forEach(item => {
      const itemName = item.name;

      if (groupedMap.has(itemName)) {
        const existingGroup = groupedMap.get(itemName);
        existingGroup.count += 1;
        existingGroup.totalAmount += this.getTotal([item]);
      } else {
        groupedMap.set(itemName, {
          name: itemName,
          count: 1,
          totalAmount: this.getTotal([item])
        });
      }
    });

    return Array.from(groupedMap.values());
  }

}
